exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-22385f2e","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogNewShareFile.vue
// module id = 1070
// module chunks = 22